<div class="grid grid-cols-3 gap-10">
  <div class="row-span-2">
    <app-card>
      <h3 class="font-bold">{{ 'page.point-cloud-detail-info.details.title' | translate }}</h3>

      <div class="mt-2 -mx-6">
        <app-detail-entry-field label="{{ 'page.point-cloud-detail-info.list.start' | translate }}">{{ (pointCloud$ | async)?.start | date:'dd-MM-yyyy HH:mm' }}</app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.point-cloud-detail-info.list.end' | translate }}">{{ (pointCloud$ | async)?.end | date:'dd-MM-yyyy HH:mm' }}</app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.point-cloud-detail-info.list.duration' | translate }}">{{ (pointCloud$ | async)?.duration }} {{ 'page.project-detail-point-clouds.list.duration.suffix' | translate }}</app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.point-cloud-detail-info.list.status' | translate }}">
          <span [class]="getStatusClass((pointCloud$ | async)?.status)">
            {{ ('page.point-cloud-detail-info.list.status.' + (pointCloud$ | async)?.status) ?? '' | translate }}
          </span>
        </app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.point-cloud-detail-info.list.uploaded-at' | translate }}">{{ (pointCloud$ | async)?.uploadedAt | date:'dd-MM-yyyy HH:mm' }}</app-detail-entry-field>
        <app-detail-entry-field label="{{ 'page.point-cloud-detail-info.list.uploaded-by' | translate }}">{{ (pointCloud$ | async)?.uploadedBy?.email ?? '-' }}</app-detail-entry-field>
      </div>

      <div class="mt-6 flex flex-col gap-1" *ngIf="(pointCloud$ | async) as pointCloud">
        <app-button text="{{ 'page.point-cloud-detail-info.download' | translate }}" [loading]="downloading" (click)="download()"></app-button>
        <app-button *ngIf="pointCloud.isTransformedToLatLng" text="{{ 'page.point-cloud-detail-info.convert' | translate }}" [loading]="converting" (click)="convert()" variant="plain"></app-button>
        <app-button *ngIf="pointCloud.tags.length > 0" text="{{ 'page.point-cloud-detail-info.tags-shapefile' | translate }}" [loading]="downloadingTagsShapefile" (click)="downloadTagsShapefile()" variant="plain"></app-button>
      </div>
    </app-card>
  </div>
  <div class="col-span-2">
    <app-card>
      <div class="-mx-6 -my-8">
        <app-map #map class="w-full block aspect-video"></app-map>
      </div>
    </app-card>
  </div>
</div>
